export const TRANSFER_COMPLIMENTARY_EXPERIENCE = 'transfer-complimentary-experience'
export const TRANSFER_INCLUSION = 'transfer-inclusion'
export const TRANSFER_ADDON = 'transfer-addon'
